// Typelizer digest 9a26673a3440a41934ecd0d459b4864d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/students/:student_id/change_wishlists/:change_wishlist_id/cancellation */
  create: (
    params: { studentId: string | number; changeWishlistId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/change_wishlists/:change_wishlist_id/cancellation', params, options),
    method: 'post',
  }),
}
